export const coreTeam = [
  {
    name: 'Marynia Kolak, MS, MFA, PhD',
    link: 'https://makosak.github.io/',
    img: 'mk.jpg',
    affiliation: '(CSDS)',
    title:
      'Health Geographer, GIScientist, Principal Investigator',
  },
  {
    name: 'Aresha Martinez-Cardoso, PhD',
    link: 'https://pbhs.uchicago.edu/program/faculty/aresha-martinez-cardoso',
    img: 'aresha.jpg',
    affiliation: 'Department of Public Health Sciences',
    title: 'Assistant Professor, Co-Principal Investigator',
  },
  {
    name: 'Qinyun Lin, PhD',
    link: 'https://www.linkedin.com/in/qinyun-lin-b72763112',
    img: 'qlin.jpg',
    affiliation: '(CSDS)',
    title:
      'Postdoctoral Fellow specializing in causal inference, social network analysis & multi-level models, Co-Principal Investigator',
  },
  {
    name: 'Mandela Gadri, MS, PhD Student',
    link: 'https://makosak.github.io/',
    img: 'mgadri.jpg',
    affiliation: '(CSDS)',
    title:
      'Research Assistant',
  },
  {
    name: 'Sarvagnya Vijay',
    link: 'https://makosak.github.io/',
    img: 'svijay.jpg',
    affiliation: '(CSDS)',
    title:
      'Software Developer, Undergraduate Research Assistant',
  },
  {
    name: 'Emily Glenn',
    link: 'https://makosak.github.io/',
    img: 'eglenn.jpg',
    affiliation: '(CSDS)',
    title:
      'Marketing Assistant, Undergraduate Research Assistant',
  },
];

export const retiredTeam = [
  {
    name: 'Xun Li, PhD',
    link: 'https://www.linkedin.com/in/xun-li-794a5b18/',
    img: 'xunli2.jpg',
    affiliation: '(CSDS)',
    title:
      'Assistant Director for Data Science & principal software engineer of GeoDa',
  },
  {
    name: 'Dylan Halpern, MCP',
    link: 'https://dylanhalpern.com/',
    img: 'dylan.jpg',
    affiliation: '(CSDS)',
    title: 'Senior Software Engineer',
  },
  {
    name: 'Susan Paykin, MPP',
    link: 'https://www.linkedin.com/in/susanpaykin/',
    img: 'susan.jpg',
    affiliation: '(CSDS)',
    title: 'Research Manager',
  },
]
